import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { EulaModalComponent } from './eula-modal.component';
import { ZiroButtonComponent } from '../../button/button.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
  declarations: [EulaModalComponent],
  exports: [EulaModalComponent],
  imports: [CommonModule, ZiroButtonComponent, TranslateModule, NgbTooltip, PipesModule],
})
export class EulaModule {}
